/*global window*/
/*global confirm*/

import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";

import {
  Card as MuiCard,
  CardContent,
  TextField as MuiTextField,
  Button,
  FormControlLabel,
  Checkbox,
  MenuItem,
} from "@material-ui/core";

import { Autocomplete } from "@material-ui/lab";

import { spacing } from "@material-ui/system";
import { BpBrokers, BpProjects } from "../services";

const Card = styled(MuiCard)(spacing);

const TextField = styled(MuiTextField)(spacing);

function NotificationsForm({ buttonName, handleSubmit }) {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);
  const [all, setAll] = useState(false);
  const [brokerOptions, setBrokerOptions] = useState([]);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [url, setURL] = useState(null);
  const [brokerValue, setBrokerValue] = useState(null);
  const [brokerInput, setBrokerInput] = useState("");
  const [target, setTarget] = useState("broker");

  React.useEffect(() => {
    (async () => {
      if (brokerInput === "") {
        setBrokerOptions(brokerValue ? [brokerValue] : []);
        return undefined;
      }

      const resList = await BpBrokers.list(0, brokerInput);

      setBrokerOptions(resList.data.rows);
    })();

    return () => { };
  }, [brokerInput]);

  React.useEffect(() => {
    BpProjects.list(0, null, 100).then((res) => {
      setProjects(res.data.rows);
    });

    return () => { };
  }, []);

  const handleChange = (setInput, value) => {
    setInput(value);
  };

  const submitForm = async (event) => {
    event.preventDefault();

    if (!title || !message) {
      return alert("Título e mensagem são obrigatórios");
    }

    if (target === 'broker' && !brokerValue?.id) {
      return alert("Escolha um corretor");
    }

    if (target === 'project' && !project) {
      return alert("Escolha um corretor");
    }

    if (target === "all") {
      if (!window.confirm("Tem certeza que deseja enviar para todos os corretores?")) {
        return;
      }
    }

    setSubmitting(true);

    const formData = {
      title,
      message,
      brokerId: brokerValue?.id,
      target,
      projectId: project,
      url
    };

    try {
      await handleSubmit(formData);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting ? (
        <CircularProgress variant="indeterminate" color="red" />
      ) : (
        <form>
          <Card mb={6}>
            <CardContent>
              <TextField
                id="title"
                label="Título"
                variant="outlined"
                fullWidth
                onChange={(event) => handleChange(setTitle, event.target.value)}
                value={title}
                my={2}
              />

              <TextField
                id="message"
                label="Mensagem"
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  handleChange(setMessage, event.target.value)
                }
                value={message}
                my={2}
              />

              <TextField
                id="url"
                label="URL"
                variant="outlined"
                fullWidth
                onChange={(event) => setURL(event.target.value)}
                value={url}
                my={2}
              />

              <TextField
                label="Destino"
                onChange={(event) => setTarget(event.target.value)}
                value={target}
                id="target"
                select
                my={2}
                fullWidth
                variant="outlined"
              >
                <MenuItem value="broker">Um corretor específico</MenuItem>
                <MenuItem value="project">Todos corretores credenciados em empreendimento</MenuItem>
                <MenuItem value="all">Todos os corretores com notificação ativa</MenuItem>
              </TextField>

              {target === 'project' &&
                <TextField
                  label="Empreendimento"
                  onChange={(event) => setProject(event.target.value)}
                  value={project}
                  id="project"
                  select
                  my={2}
                  fullWidth
                  variant="outlined"
                >
                  {projects.map((project) => (
                    <MenuItem key={project.id} value={project.id}>
                      {project.name}
                    </MenuItem>
                  ))}
                </TextField>
              }

              {target === 'broker' &&
                <Autocomplete
                  disabled={all}
                  onInputChange={(_, newInputValue) =>
                    setBrokerInput(newInputValue)
                  }
                  onChange={(event, newValue) => {
                    setBrokerValue(newValue);
                  }}
                  getOptionSelected={(option, value) =>
                    option.email === value.email
                  }
                  getOptionLabel={(option) =>
                    `${option.name} (${option.email})` || ""
                  }
                  options={brokerOptions}
                  value={brokerValue}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="broker"
                      label="Corretor"
                      variant="outlined"
                      fullWidth
                      my={2}
                    />
                  )}
                  renderOption={(option) => {
                    return (
                      <div>
                        <div>
                          <strong>{option.name}</strong>
                        </div>
                        <div>{option.email}</div>
                      </div>
                    );
                  }}
                />
              }

              <Button
                style={{ marginTop: 16 }}
                onClick={submitForm}
                variant="contained"
                color="primary"
                type="submit"
              >
                {buttonName}
              </Button>
            </CardContent>
          </Card>
        </form>
      )}
    </>
  );
}

export default NotificationsForm;
